import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { setAuthenticityToken } from "../features/session/session-slice";
import {
  setSquareMergeFields,
  setWithinPaymentReadUpdateFlow,
} from "../features/mc-square/mc-square-slice";
import {
  useGetFeatureEnabledQuery,
  useLoadSessionQuery,
} from "../features/mc-square-api/mc-square-api-slice";
import { SQUARE_MERGE_FIELD, UNKNOWN_USER } from "../constants/proptypes";
import Dashboard from "../components/dashboard";
import SetupFlowContainer from "./setup-flow-container";
import ImpersonationWarningHeader from "../components/impersonation-warning-header";
import navigationService from "../services/navigation-service";
import usePageTitle from "../hooks/use-page-title";

const ApplicationContainer = ({ authenticityToken, squareMergeFields }) => {
  const dispatch = useDispatch();
  const pageTitle = usePageTitle();

  useEffect(() => {
    dispatch(setAuthenticityToken(authenticityToken));
    dispatch(setSquareMergeFields(squareMergeFields));
    dispatch(
      setWithinPaymentReadUpdateFlow(
        navigationService.getPathname() === "/update"
      )
    );
  }, []);

  const {
    data: squareUser = UNKNOWN_USER,
    isLoading,
    refetch: refetchSession,
  } = useLoadSessionQuery();

  const { data: zendeskWidgetEnabled = false } = useGetFeatureEnabledQuery({
    feature: "zendesk_widget",
  });

  if (isLoading) return null;

  return (
    <>
      <title>{pageTitle}</title>
      <ImpersonationWarningHeader
        squareUser={squareUser}
        authenticityToken={authenticityToken}
      />
      {squareUser.setupComplete && squareUser.showDashboard ? (
        <Dashboard
          squareUser={squareUser}
          refetchSession={refetchSession}
          zendeskWidgetEnabled={zendeskWidgetEnabled}
        />
      ) : (
        <SetupFlowContainer />
      )}
    </>
  );
};

ApplicationContainer.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  squareMergeFields: SQUARE_MERGE_FIELD.isRequired,
};

export default ApplicationContainer;
